import clsx from 'clsx';
import { useMemo } from 'react';
import { Content, useContent } from 'src/contexts/ContentContext';
import {
  EventSortByFields,
  ListingSortByFields,
} from 'src/contexts/MobileSortAndFilterContext';
import { Radio, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './InventorySortingItem.css';

export const InventorySortingRadioItem = ({
  contentId,
  sortingField,
  disabled,
  isDefault,
  rightContent,
  onClick,
}: {
  contentId: ContentId;
  sortingField: ListingSortByFields | EventSortByFields;
  disabled?: boolean;
  isDefault?: boolean;
  rightContent: React.ReactNode;
  onClick: () => void;
}) => {
  const defaultText = useContent(ContentId.Default);

  const defaultPrefix = useMemo(() => {
    if (!isDefault) {
      return undefined;
    }
    return `(${defaultText})`;
  }, [defaultText, isDefault]);

  return (
    <Stack
      width="full"
      alignItems="center"
      className={clsx(styles.sortingCriteriaContainer, {
        [styles.sortingCriteriaContainerDisabled]: disabled,
      })}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <Radio value={sortingField} label="" disabled={disabled} />
      <Stack
        width="full"
        alignItems="center"
        justifyContent="spaceBetween"
        style={{ flex: 1 }}
      >
        <Stack alignItems="center" gap="s" className={styles.itemContent}>
          <Content id={contentId} />
          {defaultPrefix && (
            <span className={styles.defaultPostfix}>{defaultPrefix}</span>
          )}
        </Stack>
        {rightContent}
      </Stack>
    </Stack>
  );
};
